import axios from "./axiosService";
import services from "./base";
import { DateFormat } from "./common";


const expedientesService = {
  getAllExpedientesFiltered: async (filters) => {
    const { description, state } = filters;
    const queryParams = new URLSearchParams({
      description,
      state,
    }).toString();
    try {
      const response = await axios.get(services.urlExpediente + `/?${queryParams}`);  
      if (!response.data) throw new Error('No se encontraron registros');
      return response.data;      
    } catch (error) {
      return { error: true, message: error.message };
    }
  },
  
  getExpedienteById: async (id) => {
    try {
      const response = await axios.get(services.urlExpediente + "/" + id, { params: { id } });
      if (!response.data) throw new Error("El expediente no existe");
      const newResp = {
        ...response.data,
        fecha_creacion: DateFormat(response.data.fecha_creacion),
        fecha_sorteo: DateFormat(response.data.fecha_sorteo),
        fecha_notificacion: DateFormat(response.data.fecha_notificacion),
        fecha_aceptacion: DateFormat(response.data.fecha_aceptacion),      }
      return newResp;   
    } catch (error) {
      return { error: true, message: error.message };
    }
  },

  createExpediente: async (expediente) => {
    try {
      const response = await axios.post(services.urlExpediente, { expediente });
      if (response.status === 200 && response.data && response.data.success) {
        return { success: true, id: response.data.id, message: response.data.message };
      } else {
        return { success: false, message: "No se pudo agregar el registro" };
      }
    } catch (error) {
      console.log(error);
      return { success: false, message: `Error ${error}` };
    }
  },

  updateState: async (expediente) => {
    try {
      const response = await axios.patch(services.urlExpediente + "/state", { expediente });
      if (!response.data) throw new Error('No se encontraron registros');
      return response.data;
    } catch (error) {
      console.log(error);
      return { error: true, message: error.message };
    }
  },

  editExpediente: async (expediente) => {
    try {
      const response = await axios.put(services.urlExpediente + `/${expediente.id}`, {
        expediente,
      });
      console.log(response);
      if (response.status === 200) {
        return { success: true, message: response.data.message };
      } else {
        return { success: false, message: "No se pudo agregar el registro" };
      }
    } catch (error) {
      console.log(error);
      return { error: true, message: error.message };
    }
  },

  deleteExpediente: async (id) => {
    try {
      const response = await axios.delete(services.urlExpediente + `/${id}`);
      if (!response.data) throw new Error('No se encontraron registros');
      return response.data;
    } catch (error) {
      console.log(error);
      return { error: true, message: error.message };
    }
  },

};

export default expedientesService;
